import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import useHandleErrors from "../../utils/user.utils";
import { useUser } from "../../utils/userContext";
import Select from 'react-select';
import useConfiguration from '../../utils/ConfigurationContext';
import useCountryCodes from "../../utils/useCountryCodes";


const GuestRegistartion = () => {
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const { user } = useUser();
    const initialState = {
        firstName: "",
        middleName: "",
        lastName: "",
        contactNumber: "",
        guestEmail: "",
        startDate: "",
        endDate: "",
        reasonForVisit: "",
        requestedBy: "",
        applicationType: "",
        department: "",
        project: "",
        activeFlag: "Y",
        createdBy: user?.FirstName,
        Status: "Active",
        comments: "",
        countryCode: ""
    };
    const [formData, setFormData] = useState(initialState);
    const navigate = useNavigate();
    const handleErrors = useHandleErrors();
    const config = useConfiguration();
    const token = localStorage.getItem("token");
    const ClearIndicator = () => null;
    const { countryCodes } = useCountryCodes();


    const options = countryCodes.map((country) => ({
        value: country.value,
        label: `${country.value} (${country.label})`,
    }));

    const departmentOptions = config?.employeeManagement?.department?.map(department => ({
        value: department,
        label: department,
    }));

    const stateOptions = config?.guestRegistration?.applicationTypes?.map(application => ({
        value: application,
        label: application,
    }));

    useEffect(() => {
        const preloading = document.getElementById("preloading");
        setTimeout(() => {
            if (preloading) {
                preloading.style.display = "none";
            }
        }, 400);
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleCancel = (e) => {
        e.preventDefault();
        setFormData(initialState);
    };

    const handleKeyPress = (event) => {
        const charCode = event.charCode || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!formData.firstName) {
            toast.error("First name is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.lastName) {
            toast.error("Last name is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.contactNumber) {
            toast.error("Contact Number is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.countryCode) {
            
             toast.error("Country Code is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.guestEmail) {
            toast.error("Email is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!emailRegex.test(formData.guestEmail)) {
            toast.error("Invalid email format.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.startDate) {
            toast.error("Start Date is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.endDate) {
            toast.error("End Date is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.reasonForVisit) {
            toast.error("Reason For Visit is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.requestedBy) {
            toast.error("Requested By is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.applicationType) {
            toast.error("Application Type is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }

        const fullContactNumber = `${formData.countryCode?.split('-')[0]} ${formData.contactNumber}`;

        const data = {
            ...formData,
            contactNumber: fullContactNumber,
        };

        try {
            const path = "/guestRegistration";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.post(URL, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            if (response.status === 200) {
                setShowModal(true);
                setFormData(initialState);
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };


    const handleCloseModal = () => {
        setShowModal(false);
    };
    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div className="content-page">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col">
                            <h3 className="title mb-2">Guest Registration</h3>
                        </div>
                        <div className="col-auto">
                            <Link
                                to={"/AssetMasterReport"}
                                className="btn btn-primary mt-lg-0 mt-4"
                            >
                                <i className="ri-list-indefinite"></i> View All Assets
                            </Link>
                        </div>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="form-group col-md-6 col-lg-3">
                                                <label for="grFirstName" class="required">
                                                    First Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="firstName"
                                                    value={formData.firstName}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div class="form-group col-md-6 col-lg-3">
                                                <label for="grMiddleName">
                                                    Middle Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="middleName"
                                                    value={formData.middleName}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div class="form-group col-md-6 col-lg-3">
                                                <label for="grLastName" class="required">
                                                    Last Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="lastName"
                                                    value={formData.lastName}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div className="form-group col-md-6 col-lg-3">
                                                <label
                                                    htmlFor="contactNumber"
                                                    className="required"
                                                >
                                                    Contact Number
                                                </label>
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <Select
                                                            className="react-select-container"
                                                            classNamePrefix="react-select"
                                                            name="countryCode"
                                                            value={
                                                                options.find((option) => `${option.value}-${options.indexOf(option)}` === formData.countryCode) || null
                                                            }
                                                            onChange={(selectedOption) =>
                                                                setFormData({
                                                                    ...formData,
                                                                    countryCode: selectedOption ? selectedOption.value : '',
                                                                })
                                                            }
                                                            options={options.map((option, index) => ({
                                                                ...option,
                                                                value: `${option.value}-${index}`,
                                                            }))}
                                                            components={{ ClearIndicator }}
                                                            isClearable
                                                            menuPortalTarget={document.body}
                                                        />
                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="contactNumber"
                                                        name="contactNumber"
                                                        value={formData.contactNumber}
                                                        onChange={handleChange}
                                                        onKeyPress={handleKeyPress}
                                                        placeholder="Enter contact number"
                                                    />
                                                </div>
                                            </div>
                                            <div class="form-group col-md-6 col-lg-3">
                                                <label for="grEmail" class="required">
                                                    Guest Email
                                                </label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    name="guestEmail"
                                                    value={formData.guestEmail}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div class="form-group col-md-6 col-lg-3">
                                                <label for="grStartDate" class="required">
                                                    Start Date
                                                </label>
                                                <input type="date"
                                                    className="form-control"
                                                    name="startDate"
                                                    value={formData.startDate}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div class="form-group col-md-6 col-lg-3">
                                                <label for="grEndDate" class="required">
                                                    End Date
                                                </label>
                                                <input type="date"
                                                    className="form-control"
                                                    name="endDate"
                                                    value={formData.endDate}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <hr />
                                        <div class="row">
                                            <div class="form-group col-md-6 col-lg-6">
                                                <label for="grReasonforVisit" class="required">
                                                    Reason for Visit
                                                </label>
                                                <textarea
                                                    className="form-control"
                                                    rows="4"
                                                    name="reasonForVisit"
                                                    value={formData.reasonForVisit}
                                                    placeholder=""
                                                    onChange={handleChange}
                                                ></textarea>
                                            </div>
                                            <div class="col-lg-6 col-md-6">
                                                <div class="row">
                                                    <div class="form-group col-md-6 col-lg-6">
                                                        <label for="grRequestedBy" class="required">
                                                            Requested By
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="requestedBy"
                                                            value={formData.requestedBy}
                                                            onChange={handleChange}
                                                            placeholder="Enter Userid"
                                                        />
                                                    </div>
                                                    <div class="form-group col-md-6 col-lg-6">
                                                        <label for="grApplicationType" class="required">
                                                            Application Type
                                                        </label>
                                                        <Select
                                                            className="react-select-container"
                                                            classNamePrefix="react-select"
                                                            name="applicationType"
                                                            value={
                                                                stateOptions?.find(
                                                                    (option) =>
                                                                        option.value === formData.applicationType
                                                                ) || null
                                                            }
                                                            onChange={(selectedOption) =>
                                                                setFormData({
                                                                    ...formData,
                                                                    applicationType: selectedOption
                                                                        ? selectedOption.value
                                                                        : "",
                                                                })
                                                            }
                                                            options={stateOptions}
                                                            components={{ ClearIndicator }}
                                                            isClearable
                                                            menuPortalTarget={document.body}
                                                        />
                                                    </div>
                                                    <div class="form-group col-md-6 col-lg-6">
                                                        <label for="grDepartment">
                                                            Department
                                                        </label>
                                                        <Select
                                                            className="react-select-container"
                                                            classNamePrefix="react-select"
                                                            name="applicationType"
                                                            value={
                                                                departmentOptions?.find(
                                                                    (option) =>
                                                                        option.value === formData.department
                                                                ) || null
                                                            }
                                                            onChange={(selectedOption) =>
                                                                setFormData({
                                                                    ...formData,
                                                                    department: selectedOption
                                                                        ? selectedOption.value
                                                                        : "",
                                                                })
                                                            }
                                                            options={departmentOptions}
                                                            components={{ ClearIndicator }}
                                                            isClearable
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                control: base => ({ ...base, zIndex: 1 })
                                                            }}
                                                        />
                                                    </div>
                                                    <div class="form-group col-md-6 col-lg-6">
                                                        <label for="grProject" >
                                                            Project
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="project"
                                                            value={formData.project}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr />
                                        <div class="row">
                                            <div class="form-group col-md-12 col-lg-12">
                                                <label for="grComments">Comments</label>
                                                <textarea
                                                    className="form-control"
                                                    rows="3"
                                                    name="comments"
                                                    value={formData.comments}
                                                    placeholder="Comments"
                                                    onChange={handleChange}
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div className="row fixed-footer">
                <div className="col-lg-12 text-center">
                    <button className="btn btn-light" type="reset" onClick={handleCancel}>
                        Reset
                    </button>
                    <button
                        className="btn btn-primary"
                        type="button"
                        onClick={handleSubmit}
                    >
                        Submit <i className="ri-checkbox-circle-line"></i>
                    </button>
                </div>
            </div>
            {showModal && (
                <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="successModalLabel"
                    aria-hidden="true"
                >
                    <div
                        className="modal-dialog modal-sm modal-dialog-centered"
                        role="document"
                    >
                        <div className="modal-content shadow success-modal">
                            <div className="modal-header py-2">
                                <h6 className="modal-title" id="successModalModalLabel">
                                    Success!
                                </h6>
                                <button
                                    className="close"
                                    type="button"
                                    aria-label="Close"
                                    onClick={handleCloseModal}
                                >
                                    <span aria-hidden="true">
                                        <i className="ri-close-circle-fill font-size-20"></i>
                                    </span>
                                </button>
                            </div>
                            <div className="modal-body pb-5">
                                <div className="row">
                                    <div className="col-12 text-success text-center">
                                        <i className="ri-checkbox-circle-fill"></i>
                                    </div>
                                    <div className="col-12 text-center">
                                        Guest Registered successfully.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default GuestRegistartion;
